import React from 'react';
import {
  IonModal,
  IonButton,
  IonContent,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonGrid,
  IonRow,
  IonCol,
  IonSpinner
} from '@ionic/react';
import FieldEstimate from 'src/components/FieldEstimate';
import chilling from 'src/images/chilling.gif';

export default class BreakModal extends React.Component {
  state = { original_estimate: 900 };

  handleChange = ({ target: { value } }) => {
    console.log(value);
    this.setState({ original_estimate: value });
  };

  handleClose = () => {
    if (this.props.onClose) {
      this.setState({ original_estimate: 900 });
      this.props.onClose();
    }
  };

  handleStart = () => {
    if (this.props.onStart) {
      this.props.onStart({ original_estimate: this.state.original_estimate });
    }
  };

  handleEnd = () => {
    if (this.props.onEnd) {
      this.props.onEnd().then(() => this.handleClose());
    } else {
      this.handleClose();
    }
  };

  render() {
    const { isOpen, job, fetching } = this.props;
    const { original_estimate } = this.state;
    const isOnBreak = job.on_break;
    return (
      <React.Fragment>
        <IonModal isOpen={isOpen}>
          <IonHeader translucent>
            <IonToolbar>
              <IonTitle>Break</IonTitle>
              <IonButtons slot="end">
                {!isOnBreak && (
                  <IonButton onclick={this.handleClose}>Close</IonButton>
                )}
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonGrid>
              {isOnBreak ? (
                <IonRow className="ion-text-center">
                  <IonCol>
                    <div className="animated slideInDown fadeIn">
                      <IonRow>
                        <IonCol size="8" offset="2">
                          <img
                            src={chilling}
                            className="img-fluid"
                            alt="man chilling"
                          />
                        </IonCol>
                      </IonRow>
                    </div>
                    <div className="animated slideInUp">
                      <h2 className="animated fadeIn">You are now on break.</h2>
                      <p className="animated fadeIn mb-5">
                        Thank you for properly documenting your time.
                      </p>
                      <IonButton
                        onClick={this.handleEnd}
                        expand="block"
                        disabled={fetching}
                      >
                        {fetching ? <IonSpinner /> : 'End Break'}
                      </IonButton>
                    </div>
                  </IonCol>
                </IonRow>
              ) : (
                <IonRow>
                  <IonCol>
                    <div className="ion-text-center">
                      <h4 className="mb-5">How long will you be chillin?</h4>
                      <div className="form-group">
                        <FieldEstimate
                          value={original_estimate}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <IonButton
                      expand="block"
                      onClick={this.handleStart}
                      disabled={fetching}
                    >
                      {fetching ? <IonSpinner /> : 'Start Break'}
                    </IonButton>
                  </IonCol>
                </IonRow>
              )}
            </IonGrid>
          </IonContent>
        </IonModal>
      </React.Fragment>
    );
  }
}
